var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup-form",
    style: [_vm.type === 'define' ? 'width: 100%' : '']
  }, [_c('div', {
    staticClass: "content-form-popup"
  }, [_c('div', {
    staticClass: "header-text"
  }, [_c('div', {
    staticClass: "back-button-wrapper pointer",
    on: {
      "click": _vm.closePopup
    }
  }, [_vm.type !== 'define' ? _c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": require("@/images/modal-close.svg"),
      "alt": ""
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "pop-800 noselect"
  }, [_vm._v("Najnovšie správy")])]), _vm.unseenMessages.length === 0 ? _c('div', {
    staticClass: "image-wrapper"
  }, [_c('img', {
    staticClass: "image-bcg",
    attrs: {
      "src": require("@/images/notification-pannel-background.png"),
      "loading": "lazy",
      "alt": ""
    }
  }), _vm._m(0)]) : _c('div', _vm._l(_vm.unseenMessages, function (message, key) {
    return _c('div', {
      key: key,
      staticClass: "popup-block chat-message",
      on: {
        "click": function click($event) {
          return _vm.openChat(message);
        }
      }
    }, [_c('div', {
      staticClass: "div-block-86"
    }, [_c('div', {
      staticClass: "dark-blue-cta-text bold"
    }, [_vm.getClient(message.sender).is_temporary ? _c('span', [_vm._v("ID " + _vm._s(message.sender))]) : _c('span', [_vm._v(_vm._s(_vm.getClient(message.sender).first_name) + " " + _vm._s(_vm.getClient(message.sender).last_name))])]), !isNaN(_vm.getDate(message.created)) ? _c('div', [_vm._v(" " + _vm._s(_vm.getDate(message.created)) + "." + _vm._s(_vm.getMonth(message.created)) + " " + _vm._s(_vm.getHours(message.created)) + ":" + _vm._s(_vm.getMinutes(message.created)) + " ")]) : _vm._e()]), _c('div', {
      staticClass: "div-block-80"
    }, [message.amount_unseen !== 0 ? _c('div', {
      staticClass: "badge"
    }, [_c('div', {
      staticClass: "div-block-85"
    }, [_vm._v(_vm._s(message.amount_unseen))])]) : _vm._e(), _c('div', {
      staticClass: "open-message w-inline-block",
      staticStyle: {
        "overflow": "hidden",
        "white-space": "nowrap"
      }
    }, [_c('p', {
      staticStyle: {
        "text-overflow": "ellipsis"
      }
    }, [_vm._v(" " + _vm._s(message.content) + " ")])])])]);
  }), 0)])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "image-text"
  }, [_vm._v("všetky správy máte vybavené,"), _c('br'), _vm._v(" doprajte si chvíľu pauzy")]);

}]

export { render, staticRenderFns }